import { createRouter, createWebHistory } from 'vue-router'

// Static page routes (mirror sparkplay.in URL style: /about-us, /contact, etc)
// One route per slug instead of `/:slug`+beforeEnter — vue-router 4 aborts the whole
// navigation when beforeEnter returns false instead of falling through to the next route.
const staticRoutes = [
  'about-us',
  'contact',
  'privacy-policy',
  'terms-of-use',
  'refund-policy',
  'grievance-redressal-policy',
  'copyright-content-rights-policy',
  'content-moderation-policy',
  'code-of-ethics',
  'content-ownership-rights',
  'help-center',
  'faq',
  'device-support'
].map((slug) => ({
  path: '/' + slug,
  name: 'static:' + slug,
  component: () => import('../pages/StaticPage.vue'),
  meta: { slug }
}))

const routes = [
  { path: '/', name: 'home', component: () => import('../pages/HomePage.vue') },
  // 短剧站：只保留短剧。分集播放复用 /contents/:id（每集在后端就是一个 ContentItem）
  // 老的影片入口（外链 / 书签）统一重定向到短剧列表，避免落到 404
  { path: '/movies', redirect: '/dramas' },
  { path: '/contents/:id', name: 'content-detail', component: () => import('../pages/ContentDetailPage.vue') },
  { path: '/dramas', name: 'dramas', component: () => import('../pages/DramaListPage.vue') },
  { path: '/dramas/:id', name: 'drama-detail', component: () => import('../pages/DramaDetailPage.vue') },
  { path: '/login', name: 'login', component: () => import('../pages/LoginPage.vue') },
  { path: '/register', name: 'register', component: () => import('../pages/RegisterPage.vue') },
  { path: '/forgot-password', name: 'forgot-password', component: () => import('../pages/ForgotPasswordPage.vue') },
  { path: '/payment/:mchOrderNo', name: 'payment-step', component: () => import('../pages/PaymentPage.vue') },
  // 订阅已下线：/subscribe 老链接重定向到定价页（整剧票）
  { path: '/subscribe', redirect: '/pricing' },
  { path: '/pricing', name: 'pricing', component: () => import('../pages/PricingPage.vue') },
  { path: '/account', name: 'account', component: () => import('../pages/AccountPage.vue') },
  ...staticRoutes,
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('../pages/NotFoundPage.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Route guard: /account and /payment/* require login
const authedRouteNames = new Set(['account', 'payment-step'])
router.beforeEach((to) => {
  if (!authedRouteNames.has(to.name)) return true
  const token = localStorage.getItem('playtv.token')
  if (token) return true
  return { path: '/login', query: { redirect: to.fullPath } }
})

export default router